<ul class="breadcrumb-bar">
    <li class="breadcrumb" *ngFor="let item of items">
      <a class="child" [href]="item.url">{{ item.label }}</a>
    </li>
</ul>